// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Audit from '@deere/cps-it.warranty-model-factory/lib/audit';
import AuditInfo from './audit-info';
import DaysRemaining from '../../../shared/components/days-remaining';
import PrepareRecordButtonGroup from './prepare-record-button-group';
import {buildAuditDealerString} from '../../../shared/services/build-audit-dealer-string.js';

const AuditListItem = props =>
    <section className='audit-list-item'>
        <main>
            <div className='item-header'>
                <span className='dealer-info'>
                    {`${buildAuditDealerString(props.item.leadAccountName, props.item.city, props.item.state)}`}
                </span>
                {props.item.daysRemaining <= 90 &&
                    <DaysRemaining daysRemaining={props.item.daysRemaining}/>
                }
            </div>
            <AuditInfo item={props.item}/>
        </main>
        <footer>
            <PrepareRecordButtonGroup
                audit={props.item}
                updateSkipAudit={props.updateSkipAudit}
            />
        </footer>
    </section>;

AuditListItem.displayName = 'AuditListItem';
AuditListItem.propTypes = {
    item: PropTypes.instanceOf(Audit).isRequired,
    updateSkipAudit: PropTypes.func.isRequired
};

export default AuditListItem;



// WEBPACK FOOTER //
// ./src/tcsm/audits/components/audit-list/audit-list-item.js